import {
  ClipboardTick,
  DocumentText,
  Messages2,
  ProfileCircle
} from 'iconsax-react'

const EventIconMap = ({ objectType, theme }) => {
  switch (objectType) {
    case 'task':
      return <ClipboardTick size={theme.size.base} variant='Bulk' />
    case 'user':
      return <ProfileCircle size={theme.size.base} variant='Bulk' />
    case 'article':
      return <DocumentText size={theme.size.base} variant='Bulk' />
    case 'session':
      return <Messages2 size={theme.size.base} variant='Bulk' />
    default:
      return null
  }
}

export default EventIconMap
